import { IS_STAGING } from "./api";

/**
 * Outbound links to the marketing site. Kept in one place so a rebrand is a single edit —
 * these were previously hardcoded across seven components.
 */

// Legal/informational pages are only published on production, so they don't branch by env
// (that matches the behaviour before the usedeex.com rebrand).
export const MARKETING_URL = "https://www.usedeex.com";

export const PRIVACY_URL = `${MARKETING_URL}/privacy`;
export const TERMS_URL = `${MARKETING_URL}/terms`;
export const ABOUT_URL = `${MARKETING_URL}/about`;
export const CONTACT_URL = `${ABOUT_URL}#contact`;

// Referral links do branch — a staging referral must land on the staging site.
export const REFERRAL_BASE_URL = IS_STAGING
  ? "https://staging.usedeex.com"
  : MARKETING_URL;

export const referralLinkFor = (code: string) =>
  `${REFERRAL_BASE_URL}?r=${code}`;

export const referralTweetFor = (code: string) =>
  `https://twitter.com/intent/tweet?text=${encodeURIComponent(
    `Join me on usedeex.com! Use my referral code: ${code}`
  )}`;
